var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.componentName,{tag:"component",attrs:{"text-html":_setup.parsedText,"link":_setup.link,"image":_vm.image,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }